import styled from "styled-components";

export const ActionTextStyled = styled.span`
  color: #428bca;
  font-weight: normal;
  font-family: OpenSans;
  cursor: pointer;
`;
